import { render, staticRenderFns } from "./Envios.vue?vue&type=template&id=6f583530&scoped=true&"
import script from "./Envios.vue?vue&type=script&lang=js&"
export * from "./Envios.vue?vue&type=script&lang=js&"
import style0 from "./Envios.vue?vue&type=style&index=0&id=6f583530&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f583530",
  null
  
)

export default component.exports